var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEurobankCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3081_15930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#1E4485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9316 28.3888C22.792 28.3888 28.3435 22.8374 28.3435 15.977C28.3435 9.11663 22.8371 3.52002 15.9316 3.52002C9.07127 3.52002 3.51979 9.0715 3.51979 15.9319C3.51979 22.7922 9.07127 28.3888 15.9316 28.3888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55833 15.9319C4.55833 22.2506 9.65847 27.3508 15.9321 27.3508C22.2057 27.3508 27.351 22.2506 27.351 15.9319C27.351 9.61311 22.2509 4.55811 15.9321 4.55811C9.65847 4.55811 4.55833 9.65825 4.55833 15.9319Z",
    fill: "#D2242A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2858 7.89781C17.1956 7.85268 16.9699 7.67214 16.8345 7.62701C15.4353 7.04026 13.9008 7.71727 12.9981 9.16156L7.80769 16.9246C7.04041 18.0981 7.13068 19.6326 8.16876 20.7159C8.80064 21.3477 9.52278 21.6637 10.3352 21.6637H22.7019L20.3549 18.8202H10.0644L17.2858 7.89781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8655 14.0816L17.1955 16.6993H13.8105L18.5947 9.29736L24.0559 15.571C25.4099 17.1055 25.2294 18.8206 24.2816 20.1295L18.8655 14.0816Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3081_15930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurobankCircle);
export default __webpack_public_path__ + "static/media/eurobankCircle.9cde4f1d2c4a5eb36f336b6885099314.svg";
export { ForwardRef as ReactComponent };